







































































import Vue from 'vue';
import moment from 'moment';
import Component from 'vue-class-component';
import { AuditLog, auditLogApis, InternalSite, Employee } from '../../api';

@Component
export default class AuditLogs extends Vue {
  logs: Array<AuditLog> = [];
  total = 0;
  page = 1;
  pageSize = 15;

  sites: Array<InternalSite> = [];
  siteFilter: InternalSite | null = null;
  tagFilter = '';
  itemFilter = '';
  employeeFilter: Employee | null = null;
  loading = false;

  detailLog: AuditLog | null = null;
  detailDialogVisible = false;

  datetimeRange = [] as Date[];
  datePickerShortcuts = [
    {
      text: '最近1小时',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600000 * 1);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近12小时',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600000 * 12);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近1天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600000 * 24);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近3天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600000 * 24 * 3);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近7天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }
  ];

  async mounted() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.datetimeRange = [start, end];
    await this.showPage(1);
  }

  async showPage(page: number) {
    this.loading = true;
    this.page = page;
    const queryParams: any = {
      siteId: this.siteFilter?.id,
      employeeId: this.employeeFilter?.id,
      tag: this.tagFilter,
      itemId: this.itemFilter,
      skip: (page - 1) * this.pageSize,
      limit: this.pageSize
    };
    if (this.datetimeRange && this.datetimeRange.length === 2) {
      queryParams.startTime = moment(this.datetimeRange[0]).toISOString(true);
      queryParams.endTime = moment(this.datetimeRange[1]).toISOString(true);
    }
    try {
      const result = await auditLogApis.search(queryParams);
      this.total = result.total;
      this.logs = result.logs;
      this.sites = result.sites;
    } finally {
      this.loading = false;
    }
  }

  showDetail(log: AuditLog) {
    this.detailLog = JSON.parse(JSON.stringify(log));
    if (this.detailLog?.raw) {
      try {
        this.detailLog.raw = JSON.stringify(JSON.parse(this.detailLog.raw), null, 2);
      } catch (e) {
        //
      }
    }
    this.detailDialogVisible = true;
  }

  async changeSite() {
    this.tagFilter = '';
    this.itemFilter = '';
    await this.showPage(1);
  }

  async filterTag(log: AuditLog) {
    const idx = this.sites.findIndex(s => s.id == log.site_id);
    if (idx >= 0) {
      this.siteFilter = this.sites[idx];
      this.tagFilter = log.tag;
      this.itemFilter = log.item_id;
      await this.showPage(1);
    }
  }

  formatDate(time: string) {
    return moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
  }
}
